import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../api/axiosInstance';
import {jwtDecode} from 'jwt-decode';
import { useAuth } from '../context/AuthContext'; // adjust path if needed

// Optional: import your own CSS if desired
// import '../styles/editCloseFriends.css';

function EditCloseFriends() {
  const [closeFriends, setCloseFriends] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { userId } = useAuth();

  // Fetch the "stalkers" (i.e. users who rate me)
  // Then filter for rating=5 AND close_friends_status='approved'
  const fetchCloseFriends = async () => {
    setLoading(true);
    try {
      const myUserId = userId;
      if (!myUserId) {
        // not logged in, redirect
        navigate('/login');
        return;
      }
      const res = await axiosInstance.get(`/profile/${myUserId}/stalkers`);
      // res.data is array: [{ user_id, username, profile_url, rating, close_friends_status }, ...]
      const onlyCloseFriends = res.data.filter(
        (s) => s.rating === 5 && s.close_friends_status === 'approved'
      );
      setCloseFriends(onlyCloseFriends);
    } catch (err) {
      console.error('Error fetching close friends:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCloseFriends();
    // eslint-disable-next-line
  }, []);

  // When user clicks 'X', we call the "downgradeCloseFriend" route
  // which sets rating=4, close_friends_status=NULL
  const handleRemoveCloseFriend = async (friendId) => {
    try {
      const myUserId = userId;
      if (!myUserId) {
        navigate('/login');
        return;
      }
      await axiosInstance.put(`/profile/${myUserId}/stalkers/${friendId}/downgrade`);
      // Remove from local state so it disappears immediately
      setCloseFriends((prev) => prev.filter((f) => f.user_id !== friendId));
    } catch (err) {
      console.error('Error downgrading close friend:', err);
    }
  };

  if (loading) {
    return <div>Loading close friends...</div>;
  }

  return (
    <div style={{ padding: '1rem' }}>
      <h2>Edit Close Friends</h2>
      {closeFriends.length === 0 ? (
        <p>You currently have no approved close friends.</p>
      ) : (
        <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
          {closeFriends.map((friend) => (
            <li
              key={friend.user_id}
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '1rem',
              }}
            >
              {/* Clicking on username/picture -> navigate to that user's profile */}
              <div
                onClick={() => navigate(`/profile/${friend.user_id}`)}
                style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
              >
                <img
                  src={
                    friend.profile_url
                      ? friend.profile_url
                      : '/assets/images/default_profile.png'
                  }
                  alt={friend.username}
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                    marginRight: '0.5rem',
                  }}
                />
                <span>{friend.username}</span>
              </div>

              {/* Spacer */}
              <div style={{ flex: '1' }} />

              {/* X button to remove them from close friends */}
              <button
                onClick={() => handleRemoveCloseFriend(friend.user_id)}
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: 'red',
                  fontWeight: 'bold',
                  fontSize: '1.2rem',
                  cursor: 'pointer',
                }}
              >
                X
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default EditCloseFriends;
